import {ORIGIN_LINK} from '@spero/spero-utils/src/constants/origin-link'
import queryString from '@spero/spero-utils/src/helpers/queryString'
import openinstallMixin from '@spero/spero-utils/src/mixins/openinstall-mixin'
import storeMixin from '../mixins/store'
const VIEW_SHOW_LIMIT = 50
let HdOrigin = ORIGIN_LINK.h5hd[process.env.VUE_APP_ENV || 'test']
let SperoOrigin = ORIGIN_LINK.spero[process.env.VUE_APP_ENV || 'test']
export default {
  mixins: [storeMixin, openinstallMixin],
  methods: {
    toLogin () {
      this.SET_PHONE_LOGIN({type: 'login'})
    },
    // 股票高亮
    formatStr (stockItem) {
      let {stocks, digest} = stockItem
      let text = digest
      text = text.length > VIEW_SHOW_LIMIT ? text.substring(0, VIEW_SHOW_LIMIT) + '<span class="view-more" style="color: #4c97ff">...全文</span>' : text
      stocks = stocks || {}
      for (let item in stocks) {
        let stock = stocks[item].name
        // eslint-disable-next-line
        let stockReg = new RegExp(item.replace(/[\$\(\)\*\+\.\[\]\?\\\^\{\}\|]/g, (match) => {
          return `\\${match}`
        }), 'g')
        text = text.replace(stockReg, () => {
          return `<span class="stock-anchor" style="color: #4c97ff">${stock}</span>`
        })
      }
      return text.replace(/[\r\n]/g, (val, index) => index ? '<br>' : '')
    },
    // 文章详情页
    handleArticleDetail (item, onService) {
      if (this.USERINFO.isTourist) {
        this.toLogin()
        return
      }
      if (!onService) {
        this.permissionModel()
        return
      }
      const {id, authorUid} = item
      let search = {
        authorUid
      }
      const href = `${SperoOrigin}app-web/${queryString.objToStr(search)}#/article/${id}`
      const jumpUrl = this.inApp ? window.speroBridge.baseUrl + 'web?url=' + encodeURIComponent(href) : href
      this.urlJump(jumpUrl)
    },
    // 股票详情页
    handleStock (e, item, onService) {
      if (this.USERINFO.isTourist) {
        this.toLogin()
        return
      }
      if (!onService) {
        this.permissionModel()
        return
      }
      let oClassName = e ? e.target.className.split(' ')[0] : ''
      let oNickname = e ? e.target.innerHTML : ''
      if (oClassName === 'stock-anchor') {
        let {stocks} = item
        for (let i in stocks) {
          if (`$${oNickname}$` === i) {
            if (this.inApp) {
              if (window.YTXBridge) {
                window.YTXBridge.fireEvent(window.speroBridge.event.navigate, {
                  schema: stocks[i].url
                })
              }
            } else {
              this.openInstallInit(this.$route, {
                openinstallLink: `${window.speroBridge.schema.web}?url=${encodeURIComponent(stocks[i].url)}`
              }, true)
              console.log('股票href', `${window.speroBridge.schema.web}?url=${encodeURIComponent(stocks[i].url)}`)
            }
          }
        }
      }
    },
    // 回放视屏
    handlePlayVideo (videoItem, onService, roomId) {
      const {id, title} = videoItem
      this.$sa.click({
        eventname: '点击回放',
        title: '财商回放列表',
        productid: this.inApp ? 'gpapp' : 'h5gp',
        videoid: id,
        videotitle: title
      })
      if (this.USERINFO.isTourist) {
        this.toLogin()
        return
      }
      if (!onService) {
        this.permissionModel()
        return
      }
      let search = {
        userId: this.USERINFO.userId,
        tapeId: id
      }
      let href = `${HdOrigin}live/${queryString.objToStr(search)}#/${roomId}`
      const jumpUrl = this.inApp ? window.speroBridge.baseUrl + 'web?url=' + encodeURIComponent(href) : href
      this.urlJump(jumpUrl)
    },
    // 鉴权弹窗
    permissionModel () {
      this.$layer2({
        type: 'confirm',
        content: `<p>您没有访问此服务的权限，如有开通需要请联系您的班主任！</p>`,
        btnCancel: '切换登录',
        onCancel: () => {
          this.$layer2({content: ''})
          this.toLogin()
        },
        btnSure: '联系班主任',
        onOk: () => {
          this.$layer2({content: ''})
          location.href = 'weixin://dl/'
        }
      })
    },
    //静默授权
    silentAuthorization() {
      let appFwapi = 'https://fw-api.dyzt88.com.cn'
      let url = appFwapi + '/auth/silent?appId=wx0a5f997573289284' + '&returnUrl=' + encodeURIComponent(location.href)
      location.href = url
    },
    // 金大师用户信息
    async jinDaShiUserInfo (token) {
      const {userId} = this.USERINFO
      const {data: {code, data, message}} = await this.$jindashiApi.api(['getJinDaShiUserInfo'], {data:{token}})
      if (code === 200) {
        const {wxInfo} = data
        console.log('userId', userId)
        if (wxInfo && wxInfo.openId && userId) {
          this.recordCenterUserInfo(wxInfo.openId, userId)
        }
      } else {
        throw message
      }
    },
    // 记录openId, speroId
    async recordCenterUserInfo (openid, speroId) {
      try {
        const {data: {code, message}} = await this.$rootApi.api(['addAuthCenterUserInfo'], {
          data: {
            openid,
            speroId,
            appId: 'wx0a5f997573289284'
          }
        })
        if (code === 0) {
          this.$toast('绑定成功！')
        } else {
          throw message
        }
      } catch (err) {
        return this.$toast(err || (err && err.message))
      }
    },
    // 检测用户是否绑定
    async checkCenterUserInfo () {
      try {
        const {userId} = this.USERINFO
        const {data: {code, data, message}} = await this.$rootApi.api(['queryAuthCenterUserInfo'], {
          data: {
            speroId: userId,
            appId: 'wx0a5f997573289284'
          }
        })
        if (code === 0) {
          if (!data) {
            const {fwWechatToken} = queryString.query(location.search)
            if (fwWechatToken) {
              this.jinDaShiUserInfo(fwWechatToken)
            } else {
              return this.silentAuthorization()
            }
          }
        } else {
          throw message
        }
      } catch (err) {
        return this.$toast(err || (err && err.message))
      }
    }
  }
}
